export const DS_RADIUSES = {
  xxxs: '4px',
  xxs: '6px',
  xs: '8px',
  s: '12px',
  base: '16px',
  m: '24px',
  l: '32px',
  full: '999px',
} as const;
